import script from "./NewPlayerTip.vue?vue&type=script&lang=ts&setup=true"
export * from "./NewPlayerTip.vue?vue&type=script&lang=ts&setup=true"

import "./NewPlayerTip.vue?vue&type=style&index=0&id=4817d1f4&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4817d1f4"]])

export default __exports__